import React from 'react';
import { AppBar, TitlePortal } from 'react-admin';

import logo from './images/plgs-logo.png';

export const CustomAppBar = () => (
    <AppBar
        sx={{
            minHeight: "48px",
            '& img': {
              maxHeight: '42px'
            },
            '& .RaAppBar-toolbar': {
                padding: 0
            },
            '& .RaAppBar-menuButton': {
                color: 'white'
            },
            '& .RaAppBar-title': {
                color: 'white'
            },
            '& .MuiIconButton-root': {
                color: 'white',
                marginRight: '8px'
            },
            '& .MuiSvgIcon-root': {
                color: 'white'
            },
            '& .RaLoadingIndicator-loader': {
                color: 'white'
            },
            '& .RaLoadingIndicator-loader svg': {
                color: 'white'
            }
        }}
    >
        <img src={logo} alt="logo" />
        <TitlePortal
            sx={{
                color: 'white',
                textAlign: 'center'
            }}
        />
    </AppBar>
);

export default CustomAppBar;
